interface FontType {
  FONT_FAMILY_BLACK: string;
  FONT_FAMILY_BOLD: string;
  FONT_FAMILY_MEDIUM: string;
  FONT_FAMILY_REGULAR: string;
  FONT_FAMILY_LIGHT: string;
  FONT_FAMILY_SEMI_BOLD: string;
  [key: string]: string;
}

export const FONTS: FontType = {
  FONT_FAMILY_BLACK: "Raleway Black",
  FONT_FAMILY_BOLD: "Raleway Bold",
  FONT_FAMILY_MEDIUM: "Raleway Medium",
  FONT_FAMILY_REGULAR: "Raleway Regular",
  FONT_FAMILY_LIGHT: "Raleway Light",
  FONT_FAMILY_SEMI_BOLD: "Raleway SemiBold"
};
